GloboSwatchConfig.settings = {
            enable_collection_page: true,
            enable_product_page: true,
            out_of_stock: "cross out",
            enable_mandatory: false,
            show_add_to_cart_button: true,
            add_to_cart_ajax: false,
            show_option_name: true,
            add_to_cart_text: "Add to cart",
            added_to_cart_text: "Added to cart",
            sold_out_text: "Sold out",
            text_required: "This field is required",
            sort_option: false,
            show_one_variant_product: false,
            show_one_variant_collection: false,
            group_image: false,
            show_limit_variant: false,
            limit_variant: "5",
        };
        GloboSwatchConfig.options = [{"id":66102,"name":"Title","shop_id":11507,"option_items":[{"id":1643761,"value":"Default Title","option_id":66102,"products":null,"products_count":4,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":3,"settings":{"status":true,"enable_collection":false,"type":"swatch"},"products":null,"products_count":4,"order":1},{"id":66103,"name":"Size","shop_id":11507,"option_items":[{"id":1643762,"value":"XXS","option_id":66103,"products":null,"products_count":2,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1643763,"value":"XS","option_id":66103,"products":null,"products_count":2,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1643764,"value":"S","option_id":66103,"products":null,"products_count":2,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1643765,"value":"M","option_id":66103,"products":null,"products_count":2,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1643766,"value":"L","option_id":66103,"products":null,"products_count":2,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":3,"settings":{"status":true,"enable_collection":false,"type":"swatch"},"products":null,"products_count":2,"order":2},{"id":66104,"name":"Farbe","shop_id":11507,"option_items":[{"id":1643767,"value":"olivine","option_id":66104,"products":null,"products_count":2,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1643768,"value":"black","option_id":66104,"products":null,"products_count":2,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}},{"id":1643769,"value":"sand","option_id":66104,"products":null,"products_count":2,"select_type":1,"custom":{"color_1":"transparent","color_2":"transparent","upload_file":{"src":null,"server_url":null},"image_url":{"src":null,"server_url":null},"enable_two_color":false,"enable_upload_file":false,"enable_image_url":false}}],"display_style":1,"settings":{"status":true,"enable_collection":true,"type":"swatch"},"products":null,"products_count":2,"order":3}];
        GloboSwatchConfig.product_page= {
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#000000',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#FFFFFF',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                show_number_stock: '',
                float: 'left'
            };
            GloboSwatchConfig.collection_page ={
                customize_swatch: {
                    swatch_shape: 'circle',
                    swatch_size: 'medium',
                    border_style: 'double',
                    border_color: {
                        normal: '#9b9b9b',
                        hover: '#58468c',
                        selected: '#58468c'
                    },
                    hover_effects:{
                        background: 'no effect',
                        zoom_image: 'no zoom',
                        size_change: 'no change'
                    }
                },
                customize_button: {
                    button_corner: 'sharp',
                    button_size: 'medium',
                    border_color: {
                        normal: '#000000',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    text_style: 'default',
                    text_color: {
                        normal: '#0a0a0a',
                        hover: '#ffffff',
                        selected: '#ffffff'
                    },
                    background_color: {
                        normal: '#ffffff',
                        hover: '#000000',
                        selected: '#000000'
                    },
                    hover_effects:{
                        background: 'no effect',
                    }
                },
                float: 'left',
                carousel: 'disable'
        };